import * as React from "react";
import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {DMSConfigOptions, AllDMSConfigOptions} from "../../models";
import * as microsoftTeams from "@microsoft/teams-js";
import {get} from "../../api";
import {NetworkState} from "../ApiCallState";

export interface IConfigState extends ITeamsBaseComponentState {
    teamsId: string;
    userId: string;
    channelId: string;
    storageType: string;
    siteUrl: string;
    tenantId: string;
    CreatedFilesUpdateDMSOption: DMSConfigOptions;
    CreatedFilesNewVersion: boolean;
    CreatedFilesUseLatestComment: boolean;
    CreatedFilesRemoveFilesOption: DMSConfigOptions;
    CheckedoutFilesUpdateDMSOption: DMSConfigOptions;
    CheckedoutFilesNewVersion: boolean;
    CheckedoutFilesUseLatestComment: boolean;
    CheckedoutFilesRemoveFilesOption: DMSConfigOptions;
    CreatedFilesSyncDelay: string;
    CreatedFilesDeleteDelay: string;
    CheckedoutFilesSyncDelay: string;
    CheckedoutFilesDeleteDelay: string;
    CreateFolderStructure: boolean;
    ConfigNetworkState: NetworkState;
}

export const CustodianConfigContext = React.createContext({
    theme: null,
    teamsId: "",
    userId: "",
    channelId: "",
    storageType: "",
    siteUrl: "",
    CreatedFilesUpdateDMSOption: DMSConfigOptions.Immediately,
    CreatedFilesNewVersion: true,
    CreatedFilesUseLatestComment: true,
    CreatedFilesRemoveFilesOption: DMSConfigOptions.Immediately,
    CheckedoutFilesUpdateDMSOption: DMSConfigOptions.Immediately,
    CheckedoutFilesNewVersion: true,
    CheckedoutFilesUseLatestComment: true,
    CheckedoutFilesRemoveFilesOption: DMSConfigOptions.Manually,
    CreatedFilesSyncDelay: "10",
    CreatedFilesDeleteDelay: "10",
    CheckedoutFilesSyncDelay: "10",
    CheckedoutFilesDeleteDelay: "10",
    CreateFolderStructure: false,
    tenantId: "",
    ConfigNetworkState: NetworkState.Idle,
});

export interface IConfigProps {
    blockRender: boolean;
    children: React.ReactElement;
}

export class CustodianConfig extends TeamsBaseComponent<IConfigProps, IConfigState> {

    constructor(props: IConfigProps) {
        super(props);
        this.state = {
            theme: null,
            teamsId: this.getQueryVariable("teamsId"),
            userId: this.getQueryVariable("userId"),
            channelId: this.getQueryVariable("channelId"),
            storageType: this.getQueryVariable("storageType"),
            siteUrl: this.getQueryVariable("siteUrl"),
            CreatedFilesUpdateDMSOption: DMSConfigOptions.Immediately,
            CreatedFilesNewVersion: true,
            CreatedFilesUseLatestComment: true,
            CreatedFilesRemoveFilesOption: DMSConfigOptions.Immediately,
            CheckedoutFilesUpdateDMSOption: DMSConfigOptions.Immediately,
            CheckedoutFilesNewVersion: true,
            CheckedoutFilesUseLatestComment: true,
            CheckedoutFilesRemoveFilesOption: DMSConfigOptions.Manually,
            CreatedFilesSyncDelay: "10",
            CreatedFilesDeleteDelay: "10",
            CheckedoutFilesSyncDelay: "10",
            CheckedoutFilesDeleteDelay: "10",
            CreateFolderStructure: false,
            tenantId: this.getQueryVariable("tenantId"),
            ConfigNetworkState: NetworkState.Idle,
        };
    }

    public async componentWillMount(): Promise<void> {
        microsoftTeams.initialize();
        this.RequireConfigState();
    }

    public RequireConfigState = async () => {
        let responseTyped: AllDMSConfigOptions;
        this.setState({ConfigNetworkState: NetworkState.Loading});
        await get(
            "/api/teamsdmsintegration/GetDmsChannelConfig?teamId=" +
                this.state.teamsId +
                "&channelId=" +
                this.state.channelId +
                "&tenantId=" +
                this.state.tenantId +
                "&userId=" +
                this.state.userId
        )
            .then((response) => response.json())
            .then((response) => {
                responseTyped = response as AllDMSConfigOptions;
                if (responseTyped != null) {
                    this.setState({
                        CreatedFilesUpdateDMSOption: responseTyped.CreatedFilesUpdateDMSOption,
                        CreatedFilesNewVersion: responseTyped.CreatedFilesNewVersion,
                        CreatedFilesUseLatestComment: responseTyped.CreatedFilesUseLatestComment,
                        CreatedFilesRemoveFilesOption: responseTyped.CreatedFilesRemoveFilesOption,
                        CheckedoutFilesUpdateDMSOption: responseTyped.CheckedoutFilesUpdateDMSOption,
                        CheckedoutFilesNewVersion: responseTyped.CheckedoutFilesNewVersion,
                        CheckedoutFilesUseLatestComment: responseTyped.CheckedoutFilesUseLatestComment,
                        CheckedoutFilesRemoveFilesOption: responseTyped.CheckedoutFilesRemoveFilesOption,
                        CreatedFilesSyncDelay: responseTyped.CreatedFilesSyncDelay,
                        CreatedFilesDeleteDelay: responseTyped.CreatedFilesDeleteDelay,
                        CheckedoutFilesSyncDelay: responseTyped.CheckedoutFilesSyncDelay,
                        CheckedoutFilesDeleteDelay: responseTyped.CheckedoutFilesDeleteDelay,
                        CreateFolderStructure: responseTyped.CreateFolderStructure,
                        ConfigNetworkState: NetworkState.Success,
                    });
                }
            })
            .catch((_) => this.setState({ConfigNetworkState: NetworkState.Error}));
    };

    componentDidMount() {}

    public render() {
        if (
            this.props.blockRender &&
            this.state.ConfigNetworkState != NetworkState.Success &&
            this.state.ConfigNetworkState != NetworkState.Error
        )
            return <div />;
        return (
            <div>
                <CustodianConfigContext.Provider value={this.state}>
                    {this.props.children}
                </CustodianConfigContext.Provider>
            </div>
        );
    }
}

CustodianConfig.contextType = CustodianConfigContext;
